import { INELIGIBLE_REASON } from '../const/paymentEnterpriseEligibility';
import { getAutopayIneligibleCriteria } from './parseEligibility';
import { isPayLaterProduct } from './productTypeHelpers';
const isModifyIneligiblePriorToFirstStatement = (paymentEnterpriseEligibility) => {
    const autopayModifyIneligibleCriteria = getAutopayIneligibleCriteria(paymentEnterpriseEligibility, 'AUTOPAY_MODIFY');
    return ((autopayModifyIneligibleCriteria === null || autopayModifyIneligibleCriteria === void 0 ? void 0 : autopayModifyIneligibleCriteria.value) ===
        INELIGIBLE_REASON.statementNotGenerated);
};
const isModifyIneligibleWithin48HourWindow = (paymentEnterpriseEligibility) => {
    const autopayModifyIneligibleCriteria = getAutopayIneligibleCriteria(paymentEnterpriseEligibility, 'AUTOPAY_MODIFY');
    return ((autopayModifyIneligibleCriteria === null || autopayModifyIneligibleCriteria === void 0 ? void 0 : autopayModifyIneligibleCriteria.value) ===
        INELIGIBLE_REASON.within48HourWindow);
};
const isModifyIneligibleNotEnabledForChannelOrProduct = (paymentEnterpriseEligibility) => {
    const autopayModifyIneligibleCriteria = getAutopayIneligibleCriteria(paymentEnterpriseEligibility, 'AUTOPAY_MODIFY');
    return ((autopayModifyIneligibleCriteria === null || autopayModifyIneligibleCriteria === void 0 ? void 0 : autopayModifyIneligibleCriteria.value) ===
        INELIGIBLE_REASON.notEnabledForChannelOrProduct);
};
const isEnrollIneligibleOutstandingDueAmount = (paymentEnterpriseEligibility) => {
    const autopayEnrollIneligibleCriteria = getAutopayIneligibleCriteria(paymentEnterpriseEligibility, 'AUTOPAY_ENROLL');
    return ((autopayEnrollIneligibleCriteria === null || autopayEnrollIneligibleCriteria === void 0 ? void 0 : autopayEnrollIneligibleCriteria.value) ===
        INELIGIBLE_REASON.clearOutstandingAmountDue);
};
const isEnrollIneligibleWithin48HoursWindow = (paymentEnterpriseEligibility) => {
    const autopayEnrollIneligibleCriteria = getAutopayIneligibleCriteria(paymentEnterpriseEligibility, 'AUTOPAY_ENROLL');
    return ((autopayEnrollIneligibleCriteria === null || autopayEnrollIneligibleCriteria === void 0 ? void 0 : autopayEnrollIneligibleCriteria.value) ===
        INELIGIBLE_REASON.within48HourWindow);
};
const isManageAutopayFlow = (currentFlowValue) => {
    return currentFlowValue === 'manage';
};
const checkIneligibilityForAutopayModifyAndCancel = (paymentEnterpriseEligibility, inEligibilityReason, productType) => {
    const autopayModifyIneligibleCriteria = getAutopayIneligibleCriteria(paymentEnterpriseEligibility, 'AUTOPAY_MODIFY');
    const autopayUnEnrollIneligibleCriteria = isPayLaterProduct(productType) &&
        getAutopayIneligibleCriteria(paymentEnterpriseEligibility, 'AUTOPAY_UNENROLL');
    /*
     * please maintain the order while destructuring
     * [AUTOPAY_MODIFY,AUTOPAY_UNENROLL]
     */
    return [
        (autopayModifyIneligibleCriteria === null || autopayModifyIneligibleCriteria === void 0 ? void 0 : autopayModifyIneligibleCriteria.value) === inEligibilityReason,
        (autopayUnEnrollIneligibleCriteria === null || autopayUnEnrollIneligibleCriteria === void 0 ? void 0 : autopayUnEnrollIneligibleCriteria.value) === inEligibilityReason
    ];
};
const getAutopayModifyUnenrollIneligibility = (productType, isAutopayModifyIneligible, isAutopayUnEnrollEligible) => {
    if (isPayLaterProduct(productType)) {
        return isAutopayModifyIneligible && !isAutopayUnEnrollEligible;
    }
    return isAutopayModifyIneligible;
};
const getAutopayModifyUnenrollIneligibilityReason = (productType, isModifyInEligibleReason, isUnEnrollIneligibleReason) => {
    if (isPayLaterProduct(productType)) {
        return isModifyInEligibleReason && isUnEnrollIneligibleReason;
    }
    return isModifyInEligibleReason;
};
export { isEnrollIneligibleOutstandingDueAmount, isEnrollIneligibleWithin48HoursWindow, isManageAutopayFlow, isModifyIneligibleNotEnabledForChannelOrProduct, isModifyIneligiblePriorToFirstStatement, isModifyIneligibleWithin48HourWindow, checkIneligibilityForAutopayModifyAndCancel, getAutopayModifyUnenrollIneligibility, getAutopayModifyUnenrollIneligibilityReason };
